import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ceil from 'lodash/ceil';

import CountdownTimer from 'Components/Utility/CountdownTimer';

export default function FlashCardProgress({ startingDate, endingDate }) {
  const dealLength = endingDate - startingDate;
  const dealSecondsRemaining = endingDate - (Date.parse(new Date()) / 1000);
  const dealPercentageLeft = ceil((dealSecondsRemaining / dealLength) * 100);

  const styling = {
    keys: {
      width: `${dealPercentageLeft}%`,
    },
  };

  let progressColour = 'green';

  if (dealPercentageLeft < 70) {
    progressColour = 'yellow';
  }
  if (dealPercentageLeft < 30) {
    progressColour = 'red';
  }

  return (
    <div className="timer-progress-container">
      <div className="flash-timer-container">
        <div className="timer-text">
          <FormattedMessage
            id="flash-sale-card-progress.timer.time-left"
            defaultMessage="Ends in"
          />
        </div>
        <CountdownTimer showZero value={(endingDate * 1000)} />
      </div>
      <div className="progress-container">
        <div className="progress">
          <div
            className={`progress-bar progress-bar-striped progress-bar-animated progress-${progressColour}`}
            role="progressbar"
            style={styling.keys}
            aria-valuenow={dealPercentageLeft}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-label="This deal ends in"
            title="This deal ends in"
          />
        </div>
      </div>
    </div>
  );
}

FlashCardProgress.propTypes = {
  startingDate: PropTypes.number,
  endingDate: PropTypes.number,
};

FlashCardProgress.defaultProps = {
  startingDate: 0,
  endingDate: 0,
};
